import React, { useState, useEffect } from "react";
import AuthUser from "./AuthUser";
import { useParams } from "react-router-dom";
import moment from "moment";

const printStyles = `
  @media print {
    @page { size: A4; margin: 12mm; }
    .print-button { display: none !important; }
    nav, .navbar { display: none !important; }
  }
`;

export default function PrintSimple() {
  const { id } = useParams();
  const { http } = AuthUser();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const styleElement = document.createElement("style");
    styleElement.innerHTML = printStyles;
    document.head.appendChild(styleElement);
    return () => document.head.removeChild(styleElement);
  }, []);

  useEffect(() => {
    http
      .get(`/tasks_job_ind_print?id=${id}`)
      .then((res) => {
        const rows = res.data.data;
        setJob(Array.isArray(rows) && rows.length ? rows[0] : null);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [id]);

  if (loading) return <p className="p-3">Loading...</p>;
  if (!job) return <p className="p-3 text-danger">Job card not found.</p>;

  const branchName =
    job.branch?.branch_name ||
    (job.assiger_branch == 1 ? "K1" : job.assiger_branch == 2 ? "K2" : "—");

  return (
    <div className="container mt-3" style={{ maxWidth: "720px" }}>
      <div className="text-end mb-3">
        <button className="print-button btn btn-primary" onClick={() => window.print()}>
          Print Preview
        </button>
      </div>

      <div
        style={{
          border: "1px solid #333",
          borderRadius: "8px",
          padding: "24px",
          background: "#fff",
        }}
      >
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <img src="/logo.png" alt="Katze" width="89" height="45" />
            <h5 className="mt-2 mb-0 fw-bold">Job Card Summary</h5>
          </div>
          <div className="text-end">
            <div className="fw-bold">JC{job.id}</div>
            <div style={{ fontSize: "13px" }}>
              {moment(job.created_at).format("DD MMM, YYYY hh:mm A")}
            </div>
          </div>
        </div>

        <table className="table table-bordered mb-0">
          <tbody>
            <tr>
              <th style={{ width: "140px", background: "#f8f9fa" }}>Name</th>
              <td className="text-uppercase fw-bold">
                {job.customer?.name || "—"}
                {job.customer?.company ? (
                  <span className="text-muted fw-normal">
                    {" "}
                    ({job.customer.company})
                  </span>
                ) : null}
              </td>
            </tr>
            <tr>
              <th style={{ background: "#f8f9fa" }}>Branch</th>
              <td className="fw-bold">{branchName}</td>
            </tr>
            <tr>
              <th style={{ background: "#f8f9fa" }}>Status</th>
              <td className="fw-bold">{job.status || "—"}</td>
            </tr>
            <tr>
              <th style={{ background: "#f8f9fa", verticalAlign: "top" }}>
                Description
              </th>
              <td style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                {job.description || "—"}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
